export interface BodyMap3dCalibration {
  minX: number;
  maxX: number;
  minY: number;
  maxY: number;
  minZ: number;
  maxZ: number;
  padX: number;
  padY: number;
  offsetX: number;
  offsetY: number;
}

export const BODY_MAP_3D_CALIBRATION_MALE: BodyMap3dCalibration = {
  minX: -5.84250020980835,
  maxX: 5.84250020980835,
  minY: -0.05660000070929527,
  maxY: 20.684099197387697,
  minZ: -1.8530999422073365,
  maxZ: 1.9170000553131104,
  padX: 0.35,
  padY: 0.8,
  offsetX: 0,
  offsetY: 12,
};

export const BODY_MAP_3D_CALIBRATION_FEMALE: BodyMap3dCalibration = {
  minX: -0.4522637176513672,
  maxX: 0.4522637176513672,
  minY: 0.018181707859039307,
  maxY: 1.60700439453125,
  minZ: -0.09754951477050781,
  maxZ: 0.22034841537475586,
  padX: 0.027091,
  padY: 0.061269,
  offsetX: 0,
  offsetY: 12,
};

export function bodyMap3dCalibrationForGender(
  female: boolean,
): BodyMap3dCalibration {
  return female
    ? BODY_MAP_3D_CALIBRATION_FEMALE
    : BODY_MAP_3D_CALIBRATION_MALE;
}
